
$(window).on('load',() => {
    $(document).ready(() =>{
      $(document).on("swell:initialized",() => {
        console.log("swell initialized");
        new CampaignGrid(swellAPI.getActiveCampaigns()).renderCampaigns();      
      });

      $(document).on("swell:setup",() => {
        console.log("swell setup");
        
       let vipTiersOrder = swellAPI.getVipTiers().sort((a, b) => a.swellrequiredAmountSpentCents - b.swellrequiredAmountSpentCents);
       console.log(vipTiersOrder);
        new VipTiers(
            vipTiersOrder,
            loyaltyConstants.vipTiers.currentStatusLabel,
            loyaltyConstants.vipTiers.benefitHeaders,
            loyaltyConstants.vipTiers.benefitHeadersTitle,
            loyaltyConstants.vipTiers.benefitsList,
            swellAPI.getCustomerDetails()
          ).renderVipTiers();
        new VipTiersDashabord(swellAPI.getVipTiers(), swellAPI.getCustomerDetails()).renderVipTiersDashboard();
      });
    });
})